export const uiList = (state) => state.uiList;

export const loadingUIs = (state) => state.loadingUIs;
